// IMPORTANT: if googleRecaptcha is enabled again. Enable all useRecaptcha in the project
// import { GoogleReCaptchaProvider } from 'react-google-recaptcha-v3';
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import { ReactQueryDevtools } from '@tanstack/react-query-devtools';
import { useEffect } from 'react';
import Cookie from 'js-cookie';
import { bootstrapKeycloakStore } from 'hooks/zustandStore';
import { LEGACY_LOGIN_AuthProvider } from 'hooks/webapi';
import { ErrorProvider } from './hooks/useError';
import { StoreProvider } from './hooks/useStore';
import AppRouter from './Router/Router';
import isDevEnv from './utils/isDevEnv';
import DevTools from './DevTools';
import { AffiliateProvider } from './hooks/webapi/useAffiliate';
import initDatadogLogs from './datadog/logs';
import EventCollectorContextProvider from './hooks/context/EventCollector/EventCollectorContextProvider';

const queryClient = new QueryClient();

function App() {
  // Do not uncomment until specifically asked
  // initDatadogRUM();
  initDatadogLogs();

  useEffect(() => {
    const handleOnLoadEvent = () => {
      const cookieToken = Cookie.get('token');
      const cookieCrossLoginToken = Cookie.get('crossLoginToken');

      if (Boolean(cookieToken) && !sessionStorage.getItem('token')) {
        sessionStorage.setItem('token', cookieToken || '');
      }

      if (
        Boolean(cookieCrossLoginToken) &&
        !sessionStorage.getItem('crossLoginToken')
      ) {
        sessionStorage.setItem('crossLoginToken', cookieCrossLoginToken || '');
      }
      Cookie.remove('token');
      Cookie.remove('crossLoginToken');
    };
    bootstrapKeycloakStore();

    window.addEventListener('load', handleOnLoadEvent);

    return () => {
      window.removeEventListener('load', handleOnLoadEvent);
    };
  }, []);

  return (
    <QueryClientProvider client={queryClient}>
      <ReactQueryDevtools initialIsOpen={false} buttonPosition="bottom-left" />
      <StoreProvider>
        {/* eslint-disable-next-line react/jsx-pascal-case */}
        <LEGACY_LOGIN_AuthProvider>
          <EventCollectorContextProvider>
            {isDevEnv() && <DevTools />}
            <ErrorProvider>
              <AffiliateProvider>
                {/* <GoogleReCaptchaProvider
                reCaptchaKey={import.meta.env.VITE_RECAPTCHA_KEY as string}
              > */}
                <AppRouter />
                {/* </GoogleReCaptchaProvider> */}
              </AffiliateProvider>
            </ErrorProvider>
          </EventCollectorContextProvider>
        </LEGACY_LOGIN_AuthProvider>
      </StoreProvider>
    </QueryClientProvider>
  );
}

export default App;
